// ----------------------------------------------------------------------
export var Timeline = function Timeline(_ref) {
  var theme = _ref.theme;
  return {
    MuiTimelineConnector: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.divider
        }
      }
    }
  };
};